import PropTypes from 'prop-types';

const property = PropTypes.exact({
  street: PropTypes.string,
  apt: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
});

const insured = PropTypes.exact({
  phone: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
});

const agent = PropTypes.exact({
  organizationName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
});

const payment = PropTypes.exact({
  policyNumber: PropTypes.string,
  id: PropTypes.number,
  paymentType: PropTypes.shape({}),
  datePaid: PropTypes.string,
  amount: PropTypes.number,
});

const billing = PropTypes.oneOfType([
  PropTypes.shape({
    currentDueAmount: PropTypes.number,
    currentDueDate: PropTypes.string,
    amountPaid: PropTypes.number,
    paidDate: PropTypes.string,
    paymentPlan: PropTypes.string,
    nextInstallmentDueDate: PropTypes.string,
    nextInstallmentAmount: PropTypes.number,
    payor: PropTypes.string,
    autoPay: PropTypes.bool,
    paidInFull: PropTypes.bool,
    isMortgagee: PropTypes.bool,
    pastDueAmount: PropTypes.number,
    outstandingBalance: PropTypes.number,
    cancellationReason: PropTypes.string,
    cancellationDate: PropTypes.string,
    mortgageName: PropTypes.string,
    payorPartyId: PropTypes.string,
    accountId: PropTypes.number,
  }),
  PropTypes.exact({
    error: PropTypes.string,
  }),
]);

const coverageItem = PropTypes.shape({
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

const policy = PropTypes.shape({
  policyNumber: PropTypes.string,
  status: PropTypes.string,
  price: PropTypes.number,
  company: PropTypes.string,
  type: PropTypes.string,
  effectiveDate: PropTypes.string,
  expirationDate: PropTypes.string,
  property,
  insured,
  agent,
  payment,
  coverages: PropTypes.arrayOf(coverageItem),
  deductibles: PropTypes.arrayOf(coverageItem),
  fnol: PropTypes.shape({
    type: PropTypes.string,
    data: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
});

const api = PropTypes.shape({
  withAuth: PropTypes.shape({
    get: PropTypes.func,
    patch: PropTypes.func,
    post: PropTypes.func,
  }),
});

export default {
  api,
  policy,
  billing,
  agent,
};
